import { Box, Flex, Image, Link, Spacer, Stack, Text, useMediaQuery } from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom';

const NewFooter = () => {
    const [isLessThan1324] = useMediaQuery('(max-width: 1324px)')
    let navigate = useNavigate();
    return (
        <Stack mb="50px" justify="center" align="center" px={{ base: "14px", sm: "15vw" }} color="#1C3E64" >
            <Flex justifyContent="space-between" w="100%" maxW="1140px" direction={isLessThan1324 ? "column" : "row"} >
                <Flex justifyContent="center" alignItems="center" w={{ base: "100%", lg: "16%" }} mr="24px" >
                    <Image w={{ base: "30%", lg: "80%" }} src="https://static.vecteezy.com/system/resources/thumbnails/008/646/755/small/real-estate-logo-design-vector.jpg" />
                </Flex>
                <Flex mt="24px" pr={{ base: "0", lg: "5vw" }} columnGap="48px" rowGap="4px" fontSize="19px" flexDirection={{ base: "column", lg: "row" }} >
                    <Stack align={{ base: "center", lg: "flex-start" }}>
                        <Link onClick={() => navigate('/')} >Home</Link>
                        
                    </Stack>
                    <Stack align={{ base: "center", lg: "flex-start" }}>
                        <Link onClick={() => navigate('/marketplace')}>Marketplace</Link>
                    </Stack>
                    <Stack align={{ base: "center", lg: "flex-start" }}>
                        <Link onClick={() => navigate('/aboutus')} >About</Link>
                    </Stack>
                    <Stack align={{ base: "center", lg: "flex-start" }}>
                        <Link onClick={() => navigate('/contactus')}>Contact</Link>
                    </Stack>
                    {/* <Stack align={{ base: "center", lg: "flex-start" }}>
                        <Link >SEC filings</Link>
                    </Stack> */}


                </Flex>
            </Flex>
            <Box maxW="1140px">
                <Box my="24px">
                    <Text fontSize="14px" fontWeight="500" >
                        General Disclaimer Asset Tokenization CRE Marketplace (“Asset Tokenization”) maintains a commercial real estate technology platform through which companies and individuals who own CRE properties can offer tokenized interests of their properties to qualified investors for investment. Investments involve risk, including principal loss, and, unless otherwise stated, are not guaranteed. Targeted returns are subject to change and are based on modeling performed by the sponsor. Be sure to first consult with a qualified financial adviser and/or tax professional before implementing any strategy discussed herein. There is currently not an active secondary market for digital assets of the type featured on Asset Tokenization. The investor’s ability to liquidate will be dependent on market conditions, and there is no guarantee that a buyer will be available that can offer a price deemed acceptable by the seller. For our full disclaimers, please click here.
                    </Text>
                </Box>
                <Flex justifyItems="center" gap="2vw" flexDirection={{ base: "column", lg: "row" }}>
                    <Text textAlign="center" fontSize="16px">© 2023, All rights reserved to Asset Tokenization CRE Marketplace</Text>
                    <Spacer display={{ base: "none", lg: "block" }} />
                    <Link textAlign="center">Privacy Policy</Link>
                    <Link textAlign="center">Terms of Service</Link>


                </Flex>
            </Box>
        </Stack>
    );
}

export default NewFooter;